import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./Tax/Main";
import Form from "./Tax/Form";

// Utils
import { getData, getAlert, getDataWithComp } from "../../../utils/SamuiUtils";

import { getReport } from "../../../utils/ReportUtils";

const Tax = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [maxBiNo, setMaxBiNo] = useState();

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime();
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const refreshData = async () => {
    try {
      setMode("S");
      await fetchRealtime();
    } catch (error) {
      console.error("refreshData error:", error);
    }
  };

  const fetchRealtime = async () => {
    try {
      const masterList = await getDataWithComp(
        "API_1701_WTAX_H",
        "ORDER BY WTAX_Id desc"
      );
      if (Array.isArray(masterList) && masterList.length > 0) {
        setDataMasterList(masterList);
      } else {
        setDataMasterList([]);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onPageUpdate = (docNo) => {
    setMaxBiNo(docNo);
    setMode("U");
  };

  return (
    <div>
      <div className="Invoice">
        <div className="wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="container">
              <div className="page-inner">
                {mode === "S" ? (
                  <Main
                    name={"หนังสือหัก ณ ที่จ่าย"}
                    dataMasterList={dataMasterList}
                    onPageInsert={() => onPageInsert()}
                    onPageUpdate={(docNo) => onPageUpdate(docNo)}
                    onRefresh={refreshData}
                  />
                ) : (
                  <Form
                    callInitialize={initialize}
                    mode={mode}
                    setMode={setMode}
                    name={"หนังสือหัก ณ ที่จ่าย"}
                    docNo={maxBiNo}
                    getReport={getReport}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tax;
